export default "__VITE_ASSET__647d9654__"